
var $a0b4f895e1596b3b$exports = {};
!function(n) {
    "use strict";
    function r(n, r, t) {
        return t.a = n, t.f = r, t;
    }
    function F2(n) {
        return r(2, n, function(r) {
            return function(t) {
                return n(r, t);
            };
        });
    }
    function F3(n) {
        return r(3, n, function(r) {
            return function(t) {
                return function(e) {
                    return n(r, t, e);
                };
            };
        });
    }
    function F4(n) {
        return r(4, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return n(r, t, e, u);
                    };
                };
            };
        });
    }
    function F5(n) {
        return r(5, n, function(r) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(i) {
                            return n(r, t, e, u, i);
                        };
                    };
                };
            };
        });
    }
    function A2(n, r, t) {
        return 2 === n.a ? n.f(r, t) : n(r)(t);
    }
    function A3(n, r, t, e) {
        return 3 === n.a ? n.f(r, t, e) : n(r)(t)(e);
    }
    function A4(n, r, t, e, u) {
        return 4 === n.a ? n.f(r, t, e, u) : n(r)(t)(e)(u);
    }
    function A5(n, r, t, e, u, i) {
        return 5 === n.a ? n.f(r, t, e, u, i) : n(r)(t)(e)(u)(i);
    }
    function t(n, r) {
        for(var t, u = [], i = e(n, r, 0, u); i && (t = u.pop()); i = e(t.a, t.b, 0, u));
        return i;
    }
    function e(n, r, t, u) {
        if (n === r) return !0;
        if ("object" != typeof n || null === n || null === r) return "function" == typeof n && w(5), !1;
        if (t > 100) return u.push(i(n, r)), !0;
        for(var a in 0 > n.$ && (n = Jn(n), r = Jn(r)), n)if (!e(n[a], r[a], t + 1, u)) return !1;
        return !0;
    }
    function u(n, r, t) {
        if ("object" != typeof n) return n === r ? 0 : r > n ? -1 : 1;
        if (void 0 === n.$) return (t = u(n.a, r.a)) || (t = u(n.b, r.b)) ? t : u(n.c, r.c);
        for(; n.b && r.b && !(t = u(n.a, r.a)); n = n.b, r = r.b);
        return t || (n.b ? 1 : r.b ? -1 : 0);
    }
    function i(n, r) {
        return {
            a: n,
            b: r
        };
    }
    function a(n, r) {
        var t = {};
        for(var e in n)t[e] = n[e];
        for(var e in r)t[e] = r[e];
        return t;
    }
    function f(n, r) {
        if ("string" == typeof n) return n + r;
        if (!n.b) return r;
        var t = c(n.a, r);
        n = n.b;
        for(var e = t; n.b; n = n.b)e = e.b = c(n.a, r);
        return t;
    }
    var o = {
        $: 0
    };
    function c(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }
    var v = F2(c);
    function l(n) {
        for(var r = o, t = n.length; t--;)r = c(n[t], r);
        return r;
    }
    var s = F3(function(n, r, t) {
        for(var e = []; r.b && t.b; r = r.b, t = t.b)e.push(A2(n, r.a, t.a));
        return l(e);
    }), b = F3(function(n, r, t) {
        for(var e = Array(n), u = 0; n > u; u++)e[u] = t(r + u);
        return e;
    }), d = F2(function(n, r) {
        for(var t = Array(n), e = 0; n > e && r.b; e++)t[e] = r.a, r = r.b;
        return t.length = e, i(t, r);
    }), $ = F2(function(n, r) {
        return r[n];
    }), h = F3(function(n, r, t) {
        for(var e = t.length, u = Array(e), i = 0; e > i; i++)u[i] = t[i];
        return u[n] = r, u;
    }), g = F2(function(n, r) {
        for(var t = r.length, e = Array(t + 1), u = 0; t > u; u++)e[u] = r[u];
        return e[t] = n, e;
    }), p = F3(function(n, r, t) {
        for(var e = t.length, u = 0; e > u; u++)r = A2(n, t[u], r);
        return r;
    }), m = F3(function(n, r, t) {
        for(var e = t.length - 1; e >= 0; e--)r = A2(n, t[e], r);
        return r;
    }), y = F3(function(n, r, t) {
        return t.slice(n, r);
    }), k = F3(function(n, r, t) {
        var e = r.length, u = n - e;
        u > t.length && (u = t.length);
        for(var i = Array(e + u), a = 0; e > a; a++)i[a] = r[a];
        for(a = 0; u > a; a++)i[a + e] = t[a];
        return i;
    });
    function w(n) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + n + ".md");
    }
    var _ = F2(function(n, r) {
        return n + r;
    }), A = Math.ceil, j = Math.floor, N = Math.log;
    function q(n) {
        return {
            $: 2,
            b: n
        };
    }
    q(function(n) {
        return "number" != typeof n ? B("an INT", n) : n > -2147483647 && 2147483647 > n && (0 | n) === n ? tr(n) : !isFinite(n) || n % 1 ? B("an INT", n) : tr(n);
    }), q(function(n) {
        return "boolean" == typeof n ? tr(n) : B("a BOOL", n);
    }), q(function(n) {
        return "number" == typeof n ? tr(n) : B("a FLOAT", n);
    }), q(function(n) {
        return tr(n);
    });
    var C = q(function(n) {
        return "string" == typeof n ? tr(n) : n instanceof String ? tr(n + "") : B("a STRING", n);
    }), D = F2(function(n, r) {
        return {
            $: 6,
            d: n,
            b: r
        };
    });
    var E = F2(function(n, r) {
        return function(n, r) {
            return {
                $: 9,
                f: n,
                g: r
            };
        }(n, [
            r
        ]);
    }), L = F2(function(n, r) {
        return S(n, r);
    });
    function S(n, r) {
        switch(n.$){
            case 2:
                return n.b(r);
            case 5:
                return null === r ? tr(n.c) : B("null", r);
            case 3:
                return T(r) ? F(n.b, r, l) : B("a LIST", r);
            case 4:
                return T(r) ? F(n.b, r, O) : B("an ARRAY", r);
            case 6:
                var t = n.d;
                if ("object" != typeof r || null === r || !(t in r)) return B("an OBJECT with a field named `" + t + "`", r);
                var e = S(n.b, r[t]);
                return Tr(e) ? e : Vn(A2(nr, t, e.a));
            case 7:
                var u = n.e;
                return T(r) ? r.length > u ? (e = S(n.b, r[u]), Tr(e) ? e : Vn(A2(rr, u, e.a))) : B("a LONGER array. Need index " + u + " but only see " + r.length + " entries", r) : B("an ARRAY", r);
            case 8:
                if ("object" != typeof r || null === r || T(r)) return B("an OBJECT", r);
                var a = o;
                for(var f in r)if (r.hasOwnProperty(f)) {
                    if (e = S(n.b, r[f]), !Tr(e)) return Vn(A2(nr, f, e.a));
                    a = c(i(f, e.a), a);
                }
                return tr(dr(a));
            case 9:
                for(var v = n.f, s = n.g, b = 0; s.length > b; b++){
                    if (e = S(s[b], r), !Tr(e)) return e;
                    v = v(e.a);
                }
                return tr(v);
            case 10:
                return e = S(n.b, r), Tr(e) ? S(n.h(e.a), r) : e;
            case 11:
                for(var d = o, $ = n.g; $.b; $ = $.b){
                    if (e = S($.a, r), Tr(e)) return e;
                    d = c(e.a, d);
                }
                return Vn(er(dr(d)));
            case 1:
                return Vn(A2(Zn, n.a, r));
            case 0:
                return tr(n.a);
        }
    }
    function F(n, r, t) {
        for(var e = r.length, u = Array(e), i = 0; e > i; i++){
            var a = S(n, r[i]);
            if (!Tr(a)) return Vn(A2(rr, i, a.a));
            u[i] = a.a;
        }
        return tr(t(u));
    }
    function T(n) {
        return Array.isArray(n) || "undefined" != typeof FileList && n instanceof FileList;
    }
    function O(n) {
        return A2(Fr, n.length, function(r) {
            return n[r];
        });
    }
    function B(n, r) {
        return Vn(A2(Zn, "Expecting " + n, r));
    }
    function I(n, r) {
        if (n === r) return !0;
        if (n.$ !== r.$) return !1;
        switch(n.$){
            case 0:
            case 1:
                return n.a === r.a;
            case 2:
                return n.b === r.b;
            case 5:
                return n.c === r.c;
            case 3:
            case 4:
            case 8:
                return I(n.b, r.b);
            case 6:
                return n.d === r.d && I(n.b, r.b);
            case 7:
                return n.e === r.e && I(n.b, r.b);
            case 9:
                return n.f === r.f && P(n.g, r.g);
            case 10:
                return n.h === r.h && I(n.b, r.b);
            case 11:
                return P(n.g, r.g);
        }
    }
    function P(n, r) {
        var t = n.length;
        if (t !== r.length) return !1;
        for(var e = 0; t > e; e++)if (!I(n[e], r[e])) return !1;
        return !0;
    }
    function X(n) {
        return n;
    }
    function x(n) {
        return {
            $: 0,
            a: n
        };
    }
    function H(n) {
        return {
            $: 2,
            b: n,
            c: null
        };
    }
    var R = F2(function(n, r) {
        return {
            $: 3,
            b: n,
            d: r
        };
    }), z = F2(function(n, r) {
        return {
            $: 4,
            b: n,
            d: r
        };
    }), Q = 0;
    function M(n) {
        var r = {
            $: 0,
            e: Q++,
            f: n,
            g: null,
            h: []
        };
        return J(r), r;
    }
    var G = !1, W = [];
    function J(n) {
        if (W.push(n), !G) {
            for(G = !0; n = W.shift();)Y(n);
            G = !1;
        }
    }
    function Y(n) {
        for(; n.f;){
            var r = n.f.$;
            if (0 === r || 1 === r) {
                for(; n.g && n.g.$ !== r;)n.g = n.g.i;
                if (!n.g) return;
                n.f = n.g.b(n.f.a), n.g = n.g.i;
            } else {
                if (2 === r) return void (n.f.c = n.f.b(function(r) {
                    n.f = r, J(n);
                }));
                if (5 === r) {
                    if (0 === n.h.length) return;
                    n.f = n.f.b(n.h.shift());
                } else n.g = {
                    $: 3 === r ? 0 : 1,
                    b: n.f.b,
                    i: n.g
                }, n.f = n.f.d;
            }
        }
    }
    var K = {};
    function U(n, r, t, e, u) {
        return {
            b: n,
            c: r,
            d: t,
            e: e,
            f: u
        };
    }
    function V(n, r) {
        var t = {
            g: r,
            h: void 0
        }, e = n.c, u = n.d, i = n.e, a = n.f;
        function f(n) {
            return A2(R, f, {
                $: 5,
                b: function(r) {
                    var f = r.a;
                    return 0 === r.$ ? A3(u, t, f, n) : i && a ? A4(e, t, f.i, f.j, n) : A3(e, t, i ? f.i : f.j, n);
                }
            });
        }
        return t.h = M(A2(R, f, n.b));
    }
    var Z = F2(function(n, r) {
        return H(function(t) {
            n.g(r), t(x(0));
        });
    });
    function nn(n) {
        return function(r) {
            return {
                $: 1,
                k: n,
                l: r
            };
        };
    }
    function rn(n) {
        return {
            $: 2,
            m: n
        };
    }
    var tn, en = F2(function(n, r) {
        return {
            $: 3,
            n: n,
            o: r
        };
    }), un = [], an = !1;
    function fn(n, r, t) {
        if (un.push({
            p: n,
            q: r,
            r: t
        }), !an) {
            an = !0;
            for(var e; e = un.shift();)on(e.p, e.q, e.r);
            an = !1;
        }
    }
    function on(n, r, t) {
        var e, u = {};
        for(var i in cn(!0, r, u, null), cn(!1, t, u, null), n)(e = n[i]).h.push({
            $: "fx",
            a: u[i] || {
                i: o,
                j: o
            }
        }), J(e);
    }
    function cn(n, r, t, e) {
        switch(r.$){
            case 1:
                var u = r.k, i = function(n, r, t, e) {
                    function u(n) {
                        for(var r = t; r; r = r.t)n = r.s(n);
                        return n;
                    }
                    return A2(n ? K[r].e : K[r].f, u, e);
                }(n, u, e, r.l);
                return void (t[u] = function(n, r, t) {
                    return t = t || {
                        i: o,
                        j: o
                    }, n ? t.i = c(r, t.i) : t.j = c(r, t.j), t;
                }(n, i, t[u]));
            case 2:
                for(var a = r.m; a.b; a = a.b)cn(n, a.a, t, e);
                return;
            case 3:
                return void cn(n, r.o, t, {
                    s: r.n,
                    t: e
                });
        }
    }
    var vn = "undefined" != typeof document ? document : {};
    function ln(n, r) {
        n.appendChild(r);
    }
    function sn(n) {
        return {
            $: 0,
            a: n
        };
    }
    var bn = F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], i = 0; e.b; e = e.b){
                var a = e.a;
                i += a.b || 0, u.push(a);
            }
            return i += u.length, {
                $: 1,
                c: r,
                d: mn(t),
                e: u,
                f: n,
                b: i
            };
        });
    })(void 0);
    F2(function(n, r) {
        return F2(function(t, e) {
            for(var u = [], i = 0; e.b; e = e.b){
                var a = e.a;
                i += a.b.b || 0, u.push(a);
            }
            return i += u.length, {
                $: 2,
                c: r,
                d: mn(t),
                e: u,
                f: n,
                b: i
            };
        });
    })(void 0);
    var dn, $n = F2(function(n, r) {
        return {
            $: 4,
            j: n,
            k: r,
            b: 1 + (r.b || 0)
        };
    }), hn = F2(function(n, r) {
        return {
            $: "a0",
            n: n,
            o: r
        };
    }), gn = F2(function(n, r) {
        return {
            $: "a2",
            n: n,
            o: r
        };
    }), pn = F2(function(n, r) {
        return {
            $: "a3",
            n: n,
            o: r
        };
    });
    function mn(n) {
        for(var r = {}; n.b; n = n.b){
            var t = n.a, e = t.$, u = t.n, i = t.o;
            if ("a2" !== e) {
                var a = r[e] || (r[e] = {});
                "a3" === e && "class" === u ? yn(a, u, i) : a[u] = i;
            } else "className" === u ? yn(r, u, i) : r[u] = i;
        }
        return r;
    }
    function yn(n, r, t) {
        var e = n[r];
        n[r] = e ? e + " " + t : t;
    }
    function kn(n, r) {
        var t = n.$;
        if (5 === t) return kn(n.k || (n.k = n.m()), r);
        if (0 === t) return vn.createTextNode(n.a);
        if (4 === t) {
            for(var e = n.k, u = n.j; 4 === e.$;)"object" != typeof u ? u = [
                u,
                e.j
            ] : u.push(e.j), e = e.k;
            var i = {
                j: u,
                p: r
            };
            return (a = kn(e, i)).elm_event_node_ref = i, a;
        }
        if (3 === t) return wn(a = n.h(n.g), r, n.d), a;
        var a = n.f ? vn.createElementNS(n.f, n.c) : vn.createElement(n.c);
        tn && "a" == n.c && a.addEventListener("click", tn(a)), wn(a, r, n.d);
        for(var f = n.e, o = 0; f.length > o; o++)ln(a, kn(1 === t ? f[o] : f[o].b, r));
        return a;
    }
    function wn(n, r, t) {
        for(var e in t){
            var u = t[e];
            "a1" === e ? _n(n, u) : "a0" === e ? Nn(n, r, u) : "a3" === e ? An(n, u) : "a4" === e ? jn(n, u) : ("value" !== e && "checked" !== e || n[e] !== u) && (n[e] = u);
        }
    }
    function _n(n, r) {
        var t = n.style;
        for(var e in r)t[e] = r[e];
    }
    function An(n, r) {
        for(var t in r){
            var e = r[t];
            void 0 !== e ? n.setAttribute(t, e) : n.removeAttribute(t);
        }
    }
    function jn(n, r) {
        for(var t in r){
            var e = r[t], u = e.f, i = e.o;
            void 0 !== i ? n.setAttributeNS(u, t, i) : n.removeAttributeNS(u, t);
        }
    }
    function Nn(n, r, t) {
        var e = n.elmFs || (n.elmFs = {});
        for(var u in t){
            var i = t[u], a = e[u];
            if (i) {
                if (a) {
                    if (a.q.$ === i.$) {
                        a.q = i;
                        continue;
                    }
                    n.removeEventListener(u, a);
                }
                a = qn(r, i), n.addEventListener(u, a, dn && {
                    passive: 2 > Ir(i)
                }), e[u] = a;
            } else n.removeEventListener(u, a), e[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                dn = !0;
            }
        }));
    } catch (n) {}
    function qn(n, r) {
        function t(r) {
            var e = t.q, u = S(e.a, r);
            if (Tr(u)) {
                for(var i, a = Ir(e), f = u.a, o = a ? 3 > a ? f.a : f.z : f, c = 1 == a ? f.b : 3 == a && f.aj, v = (c && r.stopPropagation(), (2 == a ? f.b : 3 == a && f.ag) && r.preventDefault(), n); i = v.j;){
                    if ("function" == typeof i) o = i(o);
                    else for(var l = i.length; l--;)o = i[l](o);
                    v = v.p;
                }
                v(o, c);
            }
        }
        return t.q = r, t;
    }
    function Cn(n, r) {
        return n.$ == r.$ && I(n.a, r.a);
    }
    function Dn(n, r, t, e) {
        var u = {
            $: r,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return n.push(u), u;
    }
    function En(n, r, t, e) {
        if (n !== r) {
            var u = n.$, i = r.$;
            if (u !== i) {
                if (1 !== u || 2 !== i) return void Dn(t, 0, e, r);
                r = function(n) {
                    for(var r = n.e, t = r.length, e = Array(t), u = 0; t > u; u++)e[u] = r[u].b;
                    return {
                        $: 1,
                        c: n.c,
                        d: n.d,
                        e: e,
                        f: n.f,
                        b: n.b
                    };
                }(r), i = 1;
            }
            switch(i){
                case 5:
                    for(var a = n.l, f = r.l, o = a.length, c = o === f.length; c && o--;)c = a[o] === f[o];
                    if (c) return void (r.k = n.k);
                    r.k = r.m();
                    var v = [];
                    return En(n.k, r.k, v, 0), void (v.length > 0 && Dn(t, 1, e, v));
                case 4:
                    for(var l = n.j, s = r.j, b = !1, d = n.k; 4 === d.$;)b = !0, "object" != typeof l ? l = [
                        l,
                        d.j
                    ] : l.push(d.j), d = d.k;
                    for(var $ = r.k; 4 === $.$;)b = !0, "object" != typeof s ? s = [
                        s,
                        $.j
                    ] : s.push($.j), $ = $.k;
                    return b && l.length !== s.length ? void Dn(t, 0, e, r) : ((b ? function(n, r) {
                        for(var t = 0; n.length > t; t++)if (n[t] !== r[t]) return !1;
                        return !0;
                    }(l, s) : l === s) || Dn(t, 2, e, s), void En(d, $, t, e + 1));
                case 0:
                    return void (n.a !== r.a && Dn(t, 3, e, r.a));
                case 1:
                    return void Ln(n, r, t, e, Fn);
                case 2:
                    return void Ln(n, r, t, e, Tn);
                case 3:
                    if (n.h !== r.h) return void Dn(t, 0, e, r);
                    var h = Sn(n.d, r.d);
                    h && Dn(t, 4, e, h);
                    var g = r.i(n.g, r.g);
                    return void (g && Dn(t, 5, e, g));
            }
        }
    }
    function Ln(n, r, t, e, u) {
        if (n.c === r.c && n.f === r.f) {
            var i = Sn(n.d, r.d);
            i && Dn(t, 4, e, i), u(n, r, t, e);
        } else Dn(t, 0, e, r);
    }
    function Sn(n, r, t) {
        var e;
        for(var u in n)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in r) {
                var i = n[u], a = r[u];
                i === a && "value" !== u && "checked" !== u || "a0" === t && Cn(i, a) || ((e = e || {})[u] = a);
            } else (e = e || {})[u] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: n[u].f,
                o: void 0
            } : "string" == typeof n[u] ? "" : null;
        } else {
            var f = Sn(n[u], r[u] || {}, u);
            f && ((e = e || {})[u] = f);
        }
        for(var o in r)o in n || ((e = e || {})[o] = r[o]);
        return e;
    }
    function Fn(n, r, t, e) {
        var u = n.e, i = r.e, a = u.length, f = i.length;
        a > f ? Dn(t, 6, e, {
            v: f,
            i: a - f
        }) : f > a && Dn(t, 7, e, {
            v: a,
            e: i
        });
        for(var o = f > a ? a : f, c = 0; o > c; c++){
            var v = u[c];
            En(v, i[c], t, ++e), e += v.b || 0;
        }
    }
    function Tn(n, r, t, e) {
        for(var u = [], i = {}, a = [], f = n.e, o = r.e, c = f.length, v = o.length, l = 0, s = 0, b = e; c > l && v > s;){
            var d = (N = f[l]).a, $ = (q = o[s]).a, h = N.b, g = q.b, p = void 0, m = void 0;
            if (d !== $) {
                var y = f[l + 1], k = o[s + 1];
                if (y) {
                    var w = y.a, _ = y.b;
                    m = $ === w;
                }
                if (k) {
                    var A = k.a, j = k.b;
                    p = d === A;
                }
                if (p && m) En(h, j, u, ++b), Bn(i, u, d, g, s, a), b += h.b || 0, In(i, u, d, _, ++b), b += _.b || 0, l += 2, s += 2;
                else if (p) b++, Bn(i, u, $, g, s, a), En(h, j, u, b), b += h.b || 0, l += 1, s += 2;
                else if (m) In(i, u, d, h, ++b), b += h.b || 0, En(_, g, u, ++b), b += _.b || 0, l += 2, s += 1;
                else {
                    if (!y || w !== A) break;
                    In(i, u, d, h, ++b), Bn(i, u, $, g, s, a), b += h.b || 0, En(_, j, u, ++b), b += _.b || 0, l += 2, s += 2;
                }
            } else En(h, g, u, ++b), b += h.b || 0, l++, s++;
        }
        for(; c > l;){
            var N;
            b++, In(i, u, (N = f[l]).a, h = N.b, b), b += h.b || 0, l++;
        }
        for(; v > s;){
            var q, C = C || [];
            Bn(i, u, (q = o[s]).a, q.b, void 0, C), s++;
        }
        (u.length > 0 || a.length > 0 || C) && Dn(t, 8, e, {
            w: u,
            x: a,
            y: C
        });
    }
    var On = "_elmW6BL";
    function Bn(n, r, t, e, u, i) {
        var a = n[t];
        if (!a) return i.push({
            r: u,
            A: a = {
                c: 0,
                z: e,
                r: u,
                s: void 0
            }
        }), void (n[t] = a);
        if (1 === a.c) {
            i.push({
                r: u,
                A: a
            }), a.c = 2;
            var f = [];
            return En(a.z, e, f, a.r), a.r = u, void (a.s.s = {
                w: f,
                A: a
            });
        }
        Bn(n, r, t + On, e, u, i);
    }
    function In(n, r, t, e, u) {
        var i = n[t];
        if (i) {
            if (0 === i.c) {
                i.c = 2;
                var a = [];
                return En(e, i.z, a, u), void Dn(r, 9, u, {
                    w: a,
                    A: i
                });
            }
            In(n, r, t + On, e, u);
        } else {
            var f = Dn(r, 9, u, void 0);
            n[t] = {
                c: 1,
                z: e,
                r: u,
                s: f
            };
        }
    }
    function Pn(n, r, t, e) {
        Xn(n, r, t, 0, 0, r.b, e);
    }
    function Xn(n, r, t, e, u, i, a) {
        for(var f = t[e], o = f.r; o === u;){
            var c = f.$;
            if (1 === c) Pn(n, r.k, f.s, a);
            else if (8 === c) f.t = n, f.u = a, (v = f.s.w).length > 0 && Xn(n, r, v, 0, u, i, a);
            else if (9 === c) {
                f.t = n, f.u = a;
                var v, l = f.s;
                l && (l.A.s = n, (v = l.w).length > 0 && Xn(n, r, v, 0, u, i, a));
            } else f.t = n, f.u = a;
            if (!(f = t[++e]) || (o = f.r) > i) return e;
        }
        var s = r.$;
        if (4 === s) {
            for(var b = r.k; 4 === b.$;)b = b.k;
            return Xn(n, b, t, e, u + 1, i, n.elm_event_node_ref);
        }
        for(var d = r.e, $ = n.childNodes, h = 0; d.length > h; h++){
            u++;
            var g = 1 === s ? d[h] : d[h].b, p = u + (g.b || 0);
            if (!(u > o || o > p || (f = t[e = Xn($[h], g, t, e, u, p, a)]) && (o = f.r) <= i)) return e;
            u = p;
        }
        return e;
    }
    function xn(n, r) {
        for(var t = 0; r.length > t; t++){
            var e = r[t], u = e.t, i = Hn(u, e);
            u === n && (n = i);
        }
        return n;
    }
    function Hn(n, r) {
        switch(r.$){
            case 0:
                return function(n, r, t) {
                    var e = n.parentNode, u = kn(r, t);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = n.elm_event_node_ref), e && u !== n && e.replaceChild(u, n), u;
                }(n, r.s, r.u);
            case 4:
                return wn(n, r.u, r.s), n;
            case 3:
                return n.replaceData(0, n.length, r.s), n;
            case 1:
                return xn(n, r.s);
            case 2:
                return n.elm_event_node_ref ? n.elm_event_node_ref.j = r.s : n.elm_event_node_ref = {
                    j: r.s,
                    p: r.u
                }, n;
            case 6:
                for(var t = r.s, e = 0; t.i > e; e++)n.removeChild(n.childNodes[t.v]);
                return n;
            case 7:
                for(var u = (t = r.s).e, i = n.childNodes[e = t.v]; u.length > e; e++)n.insertBefore(kn(u[e], r.u), i);
                return n;
            case 9:
                if (!(t = r.s)) return n.parentNode.removeChild(n), n;
                var a = t.A;
                return void 0 !== a.r && n.parentNode.removeChild(n), a.s = xn(n, t.w), n;
            case 8:
                return function(n, r) {
                    var t = r.s, e = function(n, r) {
                        if (n) {
                            for(var t = vn.createDocumentFragment(), e = 0; n.length > e; e++){
                                var u = n[e].A;
                                ln(t, 2 === u.c ? u.s : kn(u.z, r.u));
                            }
                            return t;
                        }
                    }(t.y, r);
                    n = xn(n, t.w);
                    for(var u = t.x, i = 0; u.length > i; i++){
                        var a = u[i], f = a.A, o = 2 === f.c ? f.s : kn(f.z, r.u);
                        n.insertBefore(o, n.childNodes[a.r]);
                    }
                    return e && ln(n, e), n;
                }(n, r);
            case 5:
                return r.s(n);
            default:
                w(10);
        }
    }
    function Rn(n) {
        if (3 === n.nodeType) return sn(n.textContent);
        if (1 !== n.nodeType) return sn("");
        for(var r = o, t = n.attributes, e = t.length; e--;){
            var u = t[e];
            r = c(A2(pn, u.name, u.value), r);
        }
        var i = n.tagName.toLowerCase(), a = o, f = n.childNodes;
        for(e = f.length; e--;)a = c(Rn(f[e]), a);
        return A3(bn, i, r, a);
    }
    var zn = F4(function(n, r, t, e) {
        return function(n, r, t, e, u, i) {
            var a = A2(L, n, r ? r.flags : void 0);
            Tr(a) || w(2);
            var f = {}, o = t(a.a), c = o.a, v = i(s, c), l = function(n, r) {
                var t;
                for(var e in K){
                    var u = K[e];
                    u.a && ((t = t || {})[e] = u.a(e, r)), n[e] = V(u, r);
                }
                return t;
            }(f, s);
            function s(n, r) {
                var t = A2(e, n, c);
                v(c = t.a, r), fn(f, t.b, u(c));
            }
            return fn(f, o.b, u(c)), l ? {
                ports: l
            } : {};
        }(r, e, n.bj, n.bE, n.bB, function(r, t) {
            var e = n.ah && n.ah(r), u = n.bF, i = vn.title, a = vn.body, f = Rn(a);
            return function(n, r) {
                r(n);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (Qn(e), r(n), 1);
                }
                return function(u, i) {
                    n = u, i ? (r(n), 2 === t && (t = 1)) : (0 === t && Qn(e), t = 2);
                };
            }(t, function(n) {
                tn = e;
                var t = u(n), c = bn("body")(o)(t.ao), v = function(n, r) {
                    var t = [];
                    return En(n, r, t, 0), t;
                }(f, c);
                a = function(n, r, t, e) {
                    return 0 === t.length ? n : (Pn(n, r, t, e), xn(n, t));
                }(a, f, v, r), f = c, tn = 0, i !== t.a_ && (vn.title = i = t.a_);
            });
        });
    }), Qn = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(n) {
        return setTimeout(n, 1e3 / 60);
    });
    "undefined" != typeof document && document, "undefined" != typeof window && window;
    var Mn = F2(function(n, r) {
        return function(n, r) {
            return H(function(t) {
                Qn(function() {
                    var e = document.getElementById(n);
                    t(e ? x(r(e)) : {
                        $: 1,
                        a: Xr(n)
                    });
                });
            });
        }(r, function(r) {
            return r[n](), 0;
        });
    }), Gn = v, Wn = F3(function(n, r, t) {
        for(;;){
            if (-2 === t.$) return r;
            var e = t.d, u = n, i = A3(n, t.b, t.c, A3(Wn, n, r, t.e));
            n = u, r = i, t = e;
        }
    }), Jn = function(n) {
        return A3(Wn, F3(function(n, r, t) {
            return A2(Gn, i(n, r), t);
        }), o, n);
    }, Yn = m, Kn = F3(function(n, r, t) {
        var e = t.c, u = t.d, i = F2(function(r, t) {
            return A3(Yn, r.$ ? n : i, t, r.a);
        });
        return A3(Yn, i, A3(Yn, n, r, u), e);
    }), Un = function(n) {
        return A3(Kn, Gn, o, n);
    }, Vn = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Zn = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), nr = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), rr = F2(function(n, r) {
        return {
            $: 1,
            a: n,
            b: r
        };
    }), tr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, er = function(n) {
        return {
            $: 2,
            a: n
        };
    }, ur = _, ir = function(n) {
        return {
            $: 0,
            a: n
        };
    }, ar = {
        $: 1
    }, fr = function(n) {
        return n + "";
    }, or = F3(function(n, r, t) {
        for(;;){
            if (!t.b) return r;
            var e = t.b, u = n, i = A2(n, t.a, r);
            n = u, r = i, t = e;
        }
    }), cr = function(n) {
        return A3(or, F2(function(n, r) {
            return r + 1;
        }), 0, n);
    }, vr = s, lr = F3(function(n, r, t) {
        for(;;){
            if (u(n, r) >= 1) return t;
            var e = n, i = r - 1, a = A2(Gn, r, t);
            n = e, r = i, t = a;
        }
    }), sr = F2(function(n, r) {
        return A3(lr, n, r, o);
    }), br = F2(function(n, r) {
        return A3(vr, n, A2(sr, 0, cr(r) - 1), r);
    }), dr = function(n) {
        return A3(or, Gn, o, n);
    }, $r = 32, hr = F4(function(n, r, t, e) {
        return {
            $: 0,
            a: n,
            b: r,
            c: t,
            d: e
        };
    }), gr = [], pr = A, mr = F2(function(n, r) {
        return N(r) / N(n);
    }), yr = pr(A2(mr, 2, $r)), kr = A4(hr, 0, yr, gr, gr), wr = b, _r = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ar = j, jr = function(n) {
        return n.length;
    }, Nr = F2(function(n, r) {
        return u(n, r) > 0 ? n : r;
    }), qr = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Cr = d, Dr = F2(function(n, r) {
        for(;;){
            var t = A2(Cr, $r, n), e = t.b, u = A2(Gn, qr(t.a), r);
            if (!e.b) return dr(u);
            n = e, r = u;
        }
    }), Er = F2(function(n, r) {
        for(;;){
            var t = pr(r / $r);
            if (1 === t) return A2(Cr, $r, n).a;
            n = A2(Dr, n, o), r = t;
        }
    }), Lr = F2(function(n, r) {
        if (r.b) {
            var t = r.b * $r, e = Ar(A2(mr, $r, t - 1)), u = n ? dr(r.e) : r.e, i = A2(Er, u, r.b);
            return A4(hr, jr(r.d) + t, A2(Nr, 5, e * yr), i, r.d);
        }
        return A4(hr, jr(r.d), yr, gr, r.d);
    }), Sr = F5(function(n, r, t, e, u) {
        for(;;){
            if (0 > r) return A2(Lr, !1, {
                e: e,
                b: t / $r | 0,
                d: u
            });
            var i = _r(A3(wr, $r, r, n));
            r -= $r, e = A2(Gn, i, e);
        }
    }), Fr = F2(function(n, r) {
        if (n > 0) {
            var t = n % $r;
            return A5(Sr, r, n - t - $r, n, o, A3(wr, t, n - t, r));
        }
        return kr;
    }), Tr = function(n) {
        return !n.$;
    }, Or = E, Br = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Ir = function(n) {
        switch(n.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, Pr = function(n) {
        return n;
    }, Xr = Pr, xr = function(n) {
        for(var r = 0, t = n.charCodeAt(0), e = 43 == t || 45 == t ? 1 : 0, u = e; n.length > u; ++u){
            var i = n.charCodeAt(u);
            if (48 > i || i > 57) return ar;
            r = 10 * r + i - 48;
        }
        return u == e ? ar : ir(45 == t ? -r : r);
    }, Hr = x, Rr = Hr(0), zr = F4(function(n, r, t, e) {
        if (e.b) {
            var u = e.a, i = e.b;
            if (i.b) {
                var a = i.a, f = i.b;
                if (f.b) {
                    var o = f.a, c = f.b;
                    if (c.b) {
                        var v = c.b;
                        return A2(n, u, A2(n, a, A2(n, o, A2(n, c.a, t > 500 ? A3(or, n, r, dr(v)) : A4(zr, n, r, t + 1, v)))));
                    }
                    return A2(n, u, A2(n, a, A2(n, o, r)));
                }
                return A2(n, u, A2(n, a, r));
            }
            return A2(n, u, r);
        }
        return r;
    }), Qr = F3(function(n, r, t) {
        return A4(zr, n, r, 0, t);
    }), Mr = F2(function(n, r) {
        return A3(Qr, F2(function(r, t) {
            return A2(Gn, n(r), t);
        }), o, r);
    }), Gr = R, Wr = F2(function(n, r) {
        return A2(Gr, function(r) {
            return Hr(n(r));
        }, r);
    }), Jr = F3(function(n, r, t) {
        return A2(Gr, function(r) {
            return A2(Gr, function(t) {
                return Hr(A2(n, r, t));
            }, t);
        }, r);
    }), Yr = Z, Kr = F2(function(n, r) {
        var t = r;
        return function(n) {
            return H(function(r) {
                r(x(M(n)));
            });
        }(A2(Gr, Yr(n), t));
    });
    K.Task = U(Rr, F3(function(n, r) {
        var t;
        return A2(Wr, function() {
            return 0;
        }, (t = A2(Mr, Kr(n), r), A3(Qr, Jr(Gn), Hr(o), t)));
    }), F3(function() {
        return Hr(0);
    }), F2(function(n, r) {
        return A2(Wr, n, r);
    }));
    var Ur, Vr, Zr = nn("Task"), nt = zn, rt = function(n) {
        return {
            $: 0,
            a: n
        };
    }, tt = function(n) {
        return 0 > u(n, 1) ? 1 : u(n, 10) > 0 ? 10 : n;
    }, et = F3(function(n, r, t) {
        for(;;){
            var e = A2(Cr, $r, n), i = e.a, a = e.b;
            if (0 > u(jr(i), $r)) return A2(Lr, !0, {
                e: r,
                b: t,
                d: i
            });
            n = a, r = A2(Gn, _r(i), r), t += 1;
        }
    }), ut = {
        X: tt(4),
        _: "Player 1",
        q: (Ur = l([
            "Player 2"
        ]), Ur.b ? A3(et, Ur, o, 0) : kr)
    }, it = rn(o), at = i(ut, it), ft = en, ot = F2(function(n, r) {
        var t = n.aH;
        return r.$ ? (0, n.aI)(r.a) : t(r.a);
    })({
        aH: function(n) {
            return {
                $: 0,
                a: n
            };
        },
        aI: function(n) {
            return {
                $: 2,
                a: n
            };
        }
    }), ct = rn(o), vt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, lt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, st = F3(function(n, r, t) {
        return {
            D: r,
            k: n,
            l: t
        };
    }), bt = {
        $: 1
    }, dt = {
        $: 0
    }, $t = {
        N: o,
        D: dt,
        O: bt,
        aD: 9
    }, ht = F2(function(n, r) {
        return {
            C: n,
            _: r
        };
    })($t), gt = function(n) {
        var r, t;
        return i((t = (r = n).bl, {
            X: r.X,
            i: A3(st, o, ht(r._), A2(Mr, ht, t)),
            H: 0
        }), it);
    }, pt = F4(function(n, r, t, e) {
        var u = e.b;
        return i(a(t, {
            S: n(e.a)
        }), A2(ft, r, u));
    }), mt = function(n) {
        return n.aD - cr(n.N) - 1;
    }, yt = F2(function(n, r) {
        var t = r;
        return 0 > mt(r) ? r : a(t, {
            D: n
        });
    }), kt = F2(function(n, r) {
        return A2(yt, {
            $: 1,
            a: n
        }, r);
    }), wt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, _t = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), At = function(n) {
        var r = n.b;
        return A2(_t, 1664525 * n.a + r >>> 0, r);
    }, jt = (Vr = Pr, H(function(n) {
        n(x(Vr(Date.now())));
    })), Nt = A2(Gr, function(n) {
        var r, t;
        return Hr((r = n, t = At(A2(_t, 0, 1013904223)), At(A2(_t, t.a + r >>> 0, t.b))));
    }, jt), qt = F2(function(n, r) {
        return n(r);
    }), Ct = F3(function(n, r, t) {
        if (r.b) {
            var e = r.b, u = A2(qt, r.a, t), i = u.b;
            return A2(Gr, function() {
                return A3(Ct, n, e, i);
            }, A2(Yr, n, u.a));
        }
        return Hr(t);
    }), Dt = F3(function(n, r, t) {
        return Hr(t);
    }), Et = F2(function(n, r) {
        var t = r;
        return function(r) {
            var e = t(r), u = e.b;
            return i(n(e.a), u);
        };
    });
    K.Random = U(Nt, Ct, Dt, F2(function(n, r) {
        return A2(Et, n, r);
    }));
    var Lt, St = nn("Random"), Ft = F2(function(n, r) {
        return St(A2(Et, n, r));
    }), Tt = function(n) {
        return {
            $: 1,
            a: n
        };
    }, Ot = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Bt = function(n) {
        return 0 > n ? -n : n;
    }, It = function(n) {
        var r = n.a, t = 277803737 * (r ^ r >>> 4 + (r >>> 28));
        return (t >>> 22 ^ t) >>> 0;
    }, Pt = F2(function(n, r) {
        return function(t) {
            var e = At(t), u = Bt(r - n), a = It(e);
            return i((1 * (67108863 & It(t)) * 134217728 + 1 * (134217727 & a)) / 9007199254740992 * u + n, At(e));
        };
    }), Xt = F3(function(n, r, t) {
        for(;;){
            var e = n.a, i = n.b;
            if (!r.b) return i;
            var a = r.a, f = r.b;
            if (1 > u(t, Bt(e))) return i;
            n = a, r = f, t -= Bt(e);
        }
    }), xt = F2(function(n, r) {
        var t = function(n) {
            return Bt(n.a);
        }, e = t(n) + A3(or, ur, 0, A2(Mr, t, r));
        return A2(Et, A2(Xt, n, r), A2(Pt, 0, e));
    }), Ht = F2(function(n, r) {
        return A2(xt, i(15, Ot(0)), l([
            i(4, Ot(1)),
            i(n * r + 2, Tt(1)),
            i(4, Tt(0))
        ]));
    }), Rt = F2(function(n, r) {
        return A2(Ft, wt, A2(Ht, n, r));
    }), zt = F2(function(n, r) {
        var t = r;
        return A3(st, A2(Mr, n, t.k), n(t.D), A2(Mr, n, t.l));
    }), Qt = function(n) {
        return a(n, {
            C: $t
        });
    }, Mt = function(n) {
        var r = n.k;
        return r.b ? A3(st, o, r.a, f(r.b, A2(Gn, n.D, n.l))) : n;
    }, Gt = F2(function(n, r) {
        return {
            $: 0,
            a: n,
            b: r
        };
    }), Wt = F3(function(n, r, t) {
        var e = t;
        return a(e, {
            N: A2(Gn, A2(Gt, n, r), e.N),
            D: dt
        });
    }), Jt = F2(function(n, r) {
        var t = r.D;
        return 0 === t.$ ? r : A3(Wt, t.a, n, r);
    }), Yt = function(n) {
        return a(n, {
            O: bt
        });
    }, Kt = function(n) {
        var r = n.l;
        if (r.b) {
            var t = r.a, e = r.b;
            return A3(st, f(n.k, l([
                n.D
            ])), t, e);
        }
        return Mt(n);
    }, Ut = F2(function(n, r) {
        var t = r;
        return A3(st, t.k, n(t.D), t.l);
    }), Vt = F2(function(n, r) {
        return A2(Ut, function(r) {
            return a(r, {
                C: n(r.C)
            });
        }, r);
    }), Zt = F2(function(n, r) {
        return 1 === n ? a(r, {
            i: A2(Vt, Yt, Kt(r.i))
        }) : r;
    }), ne = F2(function(n, r) {
        return a(r, 1 === n ? {
            H: 0
        } : {
            H: 1 + r.H
        });
    }), re = F2(function(n, r) {
        return A2(Zt, n, A2(ne, n, a(r, {
            i: A2(Vt, Jt(n), r.i)
        })));
    }), te = F2(function(n, r) {
        return a(r, {
            i: A2(Vt, n, r.i)
        });
    }), ee = F2(function(n, r) {
        var t, e = r;
        return 0 > mt(r) ? a(e, {
            O: (t = n, {
                $: 2,
                a: t
            })
        }) : r;
    }), ue = F2(function(n, r) {
        return A2(Zt, n, a(r, {
            i: A2(Vt, ee(n), r.i)
        }));
    }), ie = F2(function(n, r) {
        return {
            $: 2,
            a: n,
            b: r
        };
    }), ae = F2(function(n, r) {
        var t = r.D;
        return 0 === t.$ ? r : A2(yt, A2(ie, t.a, n), r);
    }), fe = F2(function(n, r) {
        return n.$ ? A2(re, n.a, r) : A2(te, ae(n.a), r);
    }), oe = F2(function(n, r) {
        var t = r;
        switch(n.$){
            case 4:
                return i(function(n) {
                    return a(n, {
                        i: Mt(A2(zt, Qt, n.i)),
                        H: 0
                    });
                }(t), it);
            case 0:
                return i(A2(te, kt(n.a), t), A2(Rt, t.X, t.H));
            case 2:
                return i(A2(re, n.a, t), it);
            case 3:
                return i(A2(ue, n.a, t), it);
            default:
                return i(A2(fe, n.a, t), it);
        }
    }), ce = {
        $: 5
    }, ve = function(n) {
        return {
            $: 0,
            a: n
        };
    }, le = k, se = y, be = F2(function(n, r) {
        var t = jr(n), e = $r - jr(r.d) - t, u = A3(le, $r, r.d, n);
        return 0 > e ? {
            e: A2(Gn, _r(u), r.e),
            b: r.b + 1,
            d: A3(se, e, t, n)
        } : e ? {
            e: r.e,
            b: r.b,
            d: u
        } : {
            e: A2(Gn, _r(u), r.e),
            b: r.b + 1,
            d: gr
        };
    }), de = 4294967295 >>> 32 - yr, $e = g, he = function(n) {
        return [
            n
        ];
    }, ge = $, pe = h, me = F4(function(n, r, t, e) {
        var i = de & r >>> n;
        if (u(i, jr(e)) > -1) {
            if (5 === n) return A2($e, _r(t), e);
            var a = qr(A4(me, n - yr, r, t, gr));
            return A2($e, a, e);
        }
        var f = A2(ge, i, e);
        if (f.$) return a = qr(A4(me, n - yr, r, t, he(f))), A3(pe, i, a, e);
        a = qr(A4(me, n - yr, r, t, f.a));
        return A3(pe, i, a, e);
    }), ye = F2(function(n, r) {
        var e = r.a, i = r.b, a = r.c, f = jr(r.d), o = jr(n), c = e + (o - f);
        if (t(o, $r)) {
            if (u(c >>> yr, 1 << i) > 0) {
                var v = i + yr, l = A4(me, v, e, n, he(qr(a)));
                return A4(hr, c, v, l, gr);
            }
            return A4(hr, c, i, A4(me, i, e, n, a), gr);
        }
        return A4(hr, c, i, a, n);
    }), ke = F2(function(n, r) {
        var t = r.d, e = jr(n), u = $r - jr(t) - e, i = A2(ye, A3(le, $r, t, n), r);
        return 0 > u ? A2(ye, A3(se, u, e, n), i) : i;
    }), we = p, _e = F2(function(n, r) {
        var t, e = r.c, i = r.d;
        return 1 > u(r.a, 128) ? A2(ke, i, A3(we, t = F2(function(n, r) {
            return n.$ ? A2(ke, n.a, r) : A3(we, t, r, n.a);
        }), n, e)) : A2(Lr, !0, A2(be, i, A3(we, t = F2(function(n, r) {
            return n.$ ? A2(be, n.a, r) : A3(we, t, r, n.a);
        }), function(n) {
            var r = n.a, t = n.c, e = n.d, u = F2(function(n, r) {
                return n.$ ? A2(Gn, n, r) : A3(we, u, r, n.a);
            });
            return {
                e: A3(we, u, o, t),
                b: r / $r | 0,
                d: e
            };
        }(n), e)));
    }), Ae = function(n) {
        return n.a;
    }, je = F2(function(n, r) {
        n: for(;;){
            if (n > 0) {
                if (r.b) {
                    n -= 1, r = r.b;
                    continue n;
                }
                return r;
            }
            return r;
        }
    }), Ne = function(n) {
        return n >>> 5 << 5;
    }, qe = F2(function(n, r) {
        var t = r.a, e = r.c, i = r.d;
        if (n) {
            if (u(n, Ne(t)) > -1) return A4(hr, t - n, yr, gr, A3(se, n - Ne(t), jr(i), i));
            var a = n / $r | 0, f = F2(function(n, r) {
                return n.$ ? A2(Gn, n.a, r) : A3(Yn, f, r, n.a);
            }), c = A3(Yn, f, l([
                i
            ]), e), v = A2(je, a, c);
            if (v.b) {
                var s = v.a, b = v.b, d = {
                    e: o,
                    b: 0,
                    d: A3(se, n - a * $r, jr(s), s)
                };
                return A2(Lr, !0, A3(or, be, d, b));
            }
            return kr;
        }
        return r;
    }), Ce = F4(function(n, r, t, e) {
        for(;;){
            var u = A2(ge, de & t >>> n, e);
            if (u.$) return A3(se, 0, de & r, u.a);
            n -= yr, e = u.a;
        }
    }), De = F3(function(n, r, t) {
        for(;;){
            if (1 > u(n, r) || !jr(t)) return t;
            var e = A2(ge, 0, t);
            if (e.$) return t;
            n -= yr, t = e.a;
        }
    }), Ee = F3(function(n, r, t) {
        var e = de & r >>> n, u = A2(ge, e, t);
        if (u.$) return A3(se, 0, e, t);
        var i = A3(Ee, n - yr, r, u.a);
        return jr(i) ? A3(pe, e, qr(i), A3(se, 0, e + 1, t)) : A3(se, 0, e, t);
    }), Le = F2(function(n, r) {
        var e = r.a, i = r.b, a = r.c, f = r.d;
        if (t(n, e)) return r;
        if (u(n, Ne(e)) > -1) return A4(hr, n, i, a, A3(se, 0, de & n, f));
        var o = Ne(n), c = Ar(A2(mr, $r, A2(Nr, 1, o - 1))), v = A2(Nr, 5, c * yr);
        return A4(hr, n, v, A3(De, i, v, A3(Ee, i, o, a)), A4(Ce, i, n, o, a));
    }), Se = F2(function(n, r) {
        var t = r.a, e = 0 > n ? t + n : n;
        return 0 > e ? 0 : u(e, t) > 0 ? t : e;
    }), Fe = F3(function(n, r, t) {
        var e = A2(Se, r, t), i = A2(Se, n, t);
        return u(i, e) > 0 ? kr : A2(qe, i, A2(Le, e, t));
    }), Te = F2(function(n, r) {
        return A2(_e, A3(Fe, 0, n, r), A3(Fe, n + 1, Ae(r), r));
    }), Oe = F3(function(n, r, t) {
        return n(r(t));
    }), Be = z, Ie = F2(function(n, r) {
        return Zr(A2(Be, A2(Oe, A2(Oe, Hr, n), Vn), A2(Gr, A2(Oe, A2(Oe, Hr, n), tr), r)));
    }), Pe = F3(function(n, r, t) {
        return r(n(t));
    }), Xe = Mn("focus"), xe = F2(function(n, r) {
        return r.$ ? ar : ir(n(r.a));
    }), He = function(n) {
        return "player-name-" + fr(n + 1);
    }, Re = F2(function(n, r) {
        return A2(ye, A2($e, n, r.d), r);
    }), ze = F4(function(n, r, t, e) {
        var u = de & r >>> n, i = A2(ge, u, e);
        return A3(pe, u, i.$ ? _r(A3(pe, de & r, t, i.a)) : qr(A4(ze, n - yr, r, t, i.a)), e);
    }), Qe = F3(function(n, r, t) {
        var e = t.a, i = t.b, a = t.c, f = t.d;
        return 0 > n || u(n, e) > -1 ? t : u(n, Ne(e)) > -1 ? A4(hr, e, i, a, A3(pe, de & n, r, f)) : A4(hr, e, i, A4(ze, i, n, r, a), f);
    }), Me = F2(function(n, r) {
        return r.$ ? n : r.a;
    }), Ge = F2(function(n, r) {
        switch(n.$){
            case 0:
                return i(a(r, {
                    X: A2(Me, r.X, A2(xe, tt, xr(n.a)))
                }), it);
            case 1:
                var t = Ae(r.q) + 2, e = "Player " + fr(t);
                return i(a(r, {
                    q: A2(Re, e, r.q)
                }), A2(Ie, A2(Pe, function() {
                    return ce;
                }, ve), Xe(He(Ae(r.q)))));
            case 5:
                return i(r, it);
            case 2:
                return i(a(r, {
                    _: n.a
                }), it);
            case 3:
                return i(a(r, {
                    q: A3(Qe, n.a, n.b, r.q)
                }), it);
            default:
                return i(a(r, {
                    q: A2(Te, n.a, r.q)
                }), it);
        }
    }), We = F2(function(n, r) {
        var t = i(n, r.S);
        n: for(;;)switch(t.a.$){
            case 0:
                if (t.b.$) break n;
                return A4(pt, rt, ot, r, A2(Ge, t.a.a, t.b.a));
            case 1:
                if (1 === t.b.$) return A4(pt, vt, lt, r, A2(oe, t.a.a, t.b.a));
                break n;
            default:
                return A4(pt, vt, lt, r, gt(t.a.a));
        }
        return i(r, it);
    }), Je = $n, Ye = X, Ke = F2(function(n, r) {
        return A2(gn, n, Ye(r));
    }), Ue = Ke("className"), Ve = bn("div"), Ze = bn("h1"), nu = function(n) {
        return {
            $: 3,
            a: n
        };
    }, ru = function(n) {
        return {
            $: 1,
            a: n
        };
    }, tu = function(n) {
        var r = n;
        return 0 > mt(n) ? nu(r.O) : ru(r.D);
    }, eu = sn, uu = bn("h2"), iu = function(n) {
        return {
            $: 0,
            a: n
        };
    }, au = {
        $: 2
    }, fu = F2(function(n, r) {
        var t = r;
        return A3(or, A2(Pe, n, Gn), o, t.N);
    }), ou = {
        $: 0
    }, cu = F2(function(n, r) {
        var t = r;
        return 0 > mt(r) ? l([
            n(t.O)
        ]) : l([
            n(ou)
        ]);
    }), vu = F3(function(n, r, t) {
        for(;;){
            if (0 >= r) return n;
            n = A2(Gn, t, n), r -= 1;
        }
    }), lu = F2(function(n, r) {
        return A3(vu, o, n, r);
    }), su = F2(function(n, r) {
        return A2(lu, mt(r), n(0));
    }), bu = F2(function(n, r) {
        var t = r;
        return 0 > mt(r) ? o : l([
            n(t.D)
        ]);
    }), du = F2(function(n, r) {
        return f(A2(fu, A2(Pe, iu, n), r), f(A2(bu, A2(Pe, ru, n), r), f(A2(su, A2(Pe, function() {
            return au;
        }, n), r), A2(cu, A2(Pe, nu, n), r))));
    }), $u = F2(function(n, r) {
        return A2(Ve, l([
            Ue("tile"),
            Ue(n)
        ]), l([
            eu(r)
        ]));
    }), hu = A2($u, "tile-blank", "?"), gu = A2(Ve, l([
        Ue("location")
    ]), A2(lu, 3, hu)), pu = function(n) {
        return {
            $: 0,
            a: n
        };
    }, mu = hn, yu = F2(function(n, r) {
        return A2(mu, n, {
            $: 0,
            a: r
        });
    }), ku = function(n) {
        return A2(yu, "click", Br(n));
    }, wu = function(n) {
        return A2(Ve, l([
            Ue("tile tile-action tile-blank"),
            ku(pu(n))
        ]), l([
            eu("?")
        ]));
    }, _u = function(n) {
        switch(n.$){
            case 1:
                return A2($u, "tile-loading", "~");
            case 2:
                return A2($u, "tile-question", n.b ? "QQ" : "Q");
            default:
                return hu;
        }
    }, Au = F2(function(n, r) {
        return t(ir(r), function(n) {
            return 0 === n.$ ? ar : ir(n.a);
        }(n)) ? _u(n) : _u(dt);
    }), ju = function(n) {
        return n ? A2($u, "tile-answer tile-fail", "X") : A2($u, "tile-answer tile-pass", "\u2192");
    }, Nu = function(n) {
        switch(n.$){
            case 0:
                return hu;
            case 1:
                return A2($u, "tile-question", "QQ");
            default:
                return n.a ? ju(n.a) : A2($u, "tile-answer tile-pass", "\u2713");
        }
    }, qu = F2(function(n, r) {
        var e = n.b;
        return t(n.a, r) ? ju(e) : hu;
    }), Cu = function(n) {
        switch(n.$){
            case 0:
                return u = n.a, A2(Ve, l([
                    Ue("location")
                ]), A2(Mr, qu(u), l([
                    0,
                    1,
                    2
                ])));
            case 1:
                return e = n.a, A2(Ve, l([
                    Ue("location")
                ]), (t(e, dt) ? Mr(wu) : Mr(Au(e)))(l([
                    0,
                    1,
                    2
                ])));
            case 2:
                return gu;
            default:
                var r = n.a;
                return A2(Ve, l([
                    Ue("location")
                ]), l([
                    A2(Ve, l([
                        Ue("tile tile-spacer")
                    ]), o),
                    Nu(r),
                    A2(Ve, l([
                        Ue("tile tile-spacer")
                    ]), o)
                ]));
        }
        var e, u;
    }, Du = function(n) {
        var r = n._, t = n.C;
        return A2(Ve, l([
            Ue("active-player")
        ]), l([
            A2(uu, l([
                Ue("player-name")
            ]), l([
                eu(r)
            ])),
            A2(Ve, l([
                Ue("board")
            ]), A2(du, Cu, t))
        ]));
    }, Eu = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Lu = function(n) {
        return {
            $: 3,
            a: n
        };
    }, Su = {
        $: 4
    }, Fu = bn("span"), Tu = bn("a"), Ou = F3(function(n, r, t) {
        return A2(Tu, l([
            Ue("btn"),
            Ue(r),
            ku(n)
        ]), l([
            eu(t)
        ]));
    }), Bu = F2(function(n, r) {
        var t = r;
        return A3(st, A2(Mr, n(0), t.k), A2(n, 1, t.D), A2(Mr, n(2), t.l));
    }), Iu = bn("h3"), Pu = function(n) {
        return l([
            n
        ]);
    }, Xu = function(n) {
        switch(n.$){
            case 0:
                return ju(n.a.b);
            case 1:
                return _u(n.a);
            case 2:
                return hu;
            default:
                return Nu(n.a);
        }
    }, xu = function(n) {
        var r;
        return A2(Ve, l([
            Ue("other-players")
        ]), f((r = A2(Bu, F2(function(n, r) {
            var t, e, u;
            return 1 !== n ? (e = (t = r)._, u = t.C, A2(Ve, l([
                Ue("player mini-board")
            ]), l([
                A2(Iu, l([
                    Ue("player-name")
                ]), l([
                    eu(e)
                ])),
                A2(Ve, l([
                    Ue("board")
                ]), A2(Mr, A2(Pe, Pu, Ve(l([
                    Ue("location")
                ]))), A2(du, Xu, u)))
            ]))) : A2(Ve, o, o);
        }), n)).k, A2(Gn, r.D, r.l)));
    }, Hu = function(n) {
        var r, t = n, e = function(n) {
            return n.D;
        }(t.i), u = e.C;
        return A2(Ve, l([
            Ue("main")
        ]), l([
            A2(Ze, o, l([
                eu("Strike It Lucky")
            ])),
            Du(e),
            (r = tu(u), A2(Ve, l([
                Ue("controls")
            ]), function() {
                n: for(;;)switch(r.$){
                    case 3:
                        switch(r.a.$){
                            case 1:
                                return l([
                                    A2(Fu, l([
                                        Ue("label")
                                    ]), l([
                                        eu("Final Question:")
                                    ])),
                                    A3(Ou, Lu(0), "btn-pass", "Correct"),
                                    A3(Ou, Lu(1), "btn-fail", "Wrong")
                                ]);
                            case 2:
                                if (r.a.a) break n;
                                return l([
                                    A2(Fu, l([
                                        Ue("label")
                                    ]), l([
                                        eu("Congratulations!")
                                    ])),
                                    A2(Fu, l([
                                        Ue("spacer")
                                    ]), o),
                                    A3(Ou, Su, "btn-reset", "Play Again")
                                ]);
                            default:
                                break n;
                        }
                    case 1:
                        switch(r.a.$){
                            case 2:
                                return l([
                                    A2(Fu, l([
                                        Ue("label")
                                    ]), l([
                                        eu("Answer:")
                                    ])),
                                    A3(Ou, Eu(0), "btn-pass", "Correct"),
                                    A3(Ou, Eu(1), "btn-fail", "Wrong")
                                ]);
                            case 0:
                                return l([
                                    A2(Fu, l([
                                        Ue("label")
                                    ]), l([
                                        eu("Choose:")
                                    ])),
                                    A3(Ou, pu(0), "btn-location btn-top", "Top"),
                                    A3(Ou, pu(1), "btn-location btn-middle", "Middle"),
                                    A3(Ou, pu(2), "btn-location btn-Bottom", "Bottom")
                                ]);
                            default:
                                return l([
                                    A2(Fu, l([
                                        Ue("label")
                                    ]), l([
                                        eu("Picking a question...")
                                    ]))
                                ]);
                        }
                    default:
                        break n;
                }
                return o;
            }())),
            xu(t.i)
        ]));
    }, Ru = {
        $: 1
    }, zu = function(n) {
        return {
            $: 4,
            a: n
        };
    }, Qu = function(n) {
        return {
            $: 0,
            a: n
        };
    }, Mu = function(n) {
        return {
            $: 2,
            a: n
        };
    }, Gu = F2(function(n, r) {
        return {
            $: 3,
            a: n,
            b: r
        };
    }), Wu = bn("form"), Ju = bn("input"), Yu = Ke("type"), Ku = Ke("value"), Uu = F2(function(n, r) {
        return A2(Ju, l([
            Yu("button"),
            Ue("form-btn btn"),
            Ku(n),
            ku(r)
        ]), o);
    }), Vu = Ke("max"), Zu = Ke("min"), ni = function(n) {
        return i(n, !0);
    }, ri = F2(function(n, r) {
        return A2(mu, n, {
            $: 1,
            a: r
        });
    }), ti = D, ei = C, ui = A2(F2(function(n, r) {
        return A3(Qr, ti, r, n);
    }), l([
        "target",
        "value"
    ]), ei), ii = function(n) {
        return A2(ri, "input", A2(Or, ni, A2(Or, n, ui)));
    }, ai = Ke("title"), fi = function(n) {
        return fr(n);
    }, oi = F2(function(n, r) {
        return l([
            A2(Fu, l([
                Ue("form-range-label")
            ]), l([
                eu(fi(1))
            ])),
            A2(Ju, l([
                Yu("range"),
                Ue("form-input"),
                Zu(fi(1)),
                Vu(fi(10)),
                Ku(fi(r)),
                ii(n),
                ai(fi(r))
            ]), o),
            A2(Fu, l([
                Ue("form-range-label")
            ]), l([
                eu(fi(10))
            ]))
        ]);
    }), ci = Ke("id"), vi = Ke("placeholder"), li = X, si = F2(function(n, r) {
        return A2(gn, n, li(r));
    })("required"), bi = F3(function(n, r, t) {
        return A2(Ju, l([
            Yu("text"),
            Ue("form-input form-input-text"),
            Ku(t),
            ii(n),
            ci(r),
            vi("Player Name"),
            si(!0)
        ]), o);
    }), di = bn("label"), $i = bn("li"), hi = bn("ol"), gi = function(n) {
        return i(n, !0);
    }, pi = F2(function(n, r) {
        return A2(mu, n, {
            $: 2,
            a: r
        });
    }), mi = function(n) {
        return {
            X: n.X,
            bl: Un(n.q),
            _: n._
        };
    }, yi = function(n) {
        var r, t;
        return A2(Ve, l([
            Ue("setup")
        ]), l([
            A2(Ze, o, l([
                eu("Strike It Lucky")
            ])),
            A2(Wu, l([
                (t = mi(n), r = {
                    $: 1,
                    a: t
                }, A2(pi, "submit", A2(Or, gi, Br(r))))
            ]), l([
                A2(uu, o, l([
                    eu("Settings")
                ])),
                A2(Ve, l([
                    Ue("input-group difficulty")
                ]), l([
                    A2(di, l([
                        Ue("form-label")
                    ]), l([
                        eu("Difficulty")
                    ])),
                    A2(Ve, l([
                        Ue("form-input-group")
                    ]), A2(oi, A2(Pe, Qu, ve), n.X))
                ])),
                A2(Ve, l([
                    Ue("form-label")
                ]), l([
                    eu("Players")
                ])),
                A2(hi, l([
                    Ue("form-list player-name")
                ]), A2(Gn, A2($i, o, l([
                    A2(Ve, l([
                        Ue("form-input-group")
                    ]), l([
                        A3(bi, A2(Pe, Mu, ve), "player-name-0", n._)
                    ]))
                ])), A2(br, F2(function(n, r) {
                    return A2($i, o, l([
                        A2(Ve, l([
                            Ue("form-input-group")
                        ]), l([
                            A3(bi, A2(Pe, Gu(n), ve), He(n), r),
                            A2(Uu, "X", ve(zu(n)))
                        ]))
                    ]));
                }), Un(n.q)))),
                A2(Ve, l([
                    Ue("input-group form-controls")
                ]), l([
                    A2(Uu, "Add Player", ve(Ru)),
                    A2(Fu, l([
                        Ue("spacer")
                    ]), o),
                    A2(Ju, l([
                        Yu("submit"),
                        Ue("form-btn btn"),
                        Ku("Start Game")
                    ]), o)
                ]))
            ]))
        ]));
    };
    Lt = {
        Main: {
            init: nt({
                bj: function() {
                    var n = at.b;
                    return i({
                        S: rt(at.a)
                    }, A2(ft, ot, n));
                },
                bB: function() {
                    return ct;
                },
                bE: We,
                bF: function(n) {
                    var r = n.S;
                    return r.$ ? {
                        ao: l([
                            A2(Je, lt, Hu(r.a))
                        ]),
                        a_: "Strike It Lucky"
                    } : {
                        ao: l([
                            A2(Je, ot, yi(r.a))
                        ]),
                        a_: "Setup: Strike It Lucky"
                    };
                }
            })(Br(0))(0)
        }
    }, n.Elm ? function n(r, t) {
        for(var e in t)e in r ? "init" == e ? w(6) : n(r[e], t[e]) : r[e] = t[e];
    }(n.Elm, Lt) : n.Elm = Lt;
}($a0b4f895e1596b3b$exports);


document.addEventListener("DOMContentLoaded", function() {
    const mountPoint = document.querySelector("main");
    (0, $a0b4f895e1596b3b$exports.Elm).Main.init({
        node: mountPoint,
        flags: null
    });
});


//# sourceMappingURL=index.45f00396.js.map
